
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import { Section, Container, Heading, TextBlock, Main } from '@ui'
import useTranslation from 'next-translate/useTranslation'

import texts from 'locales/terms-of-service'

export default function Page() {
    const { lang } = useTranslation()

    return (
        <Main className="bg-sand-light m:bg-white">
            <Section className="Section--text-page">
                <Container className="pt-13 m:pt-19 pb-20 m:pb-18 subrich">
                    {texts[lang]}
                </Container>
            </Section>
        </Main>
    )
}


    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/terms-of-service',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  